<div
    class="control-box"
    [class.border]="!isSelected"
    [class.is-selected]="isSelected"
    (click)="controlBoxClick()"
    (keydown.enter)="controlBoxClick()"
    (keydown.space)="$event.preventDefault(); controlBoxClick()"
    tabindex="0"
    role="button"
    [attr.aria-pressed]="isSelected"
>
    <div class="headers">
        <mat-icon class="icon">{{icon}}</mat-icon>
        <h2 class="heading-3">{{ headerText }}</h2>
    </div>

    <div>{{detailText}}</div>
</div>
